import { Injectable } from '@angular/core';
import { EnfantModel } from '../models/enfant.model';
import { TypeCodePostalEnum } from '../enum/type-code-postal.enum';


@Injectable({ providedIn: 'root' })
export class EnfantService {

    indexEnfants: string[] = [
        'premier', 'deuxième', 'troisième', 'quatrième', 'cinquième', 
        'sixième', 'septième', 'huitième', 'neuvième', 'dixième',
        'onzième', 'douzième', 'treizième', 'quatorzième', 'quinzième', 
        'seizième', 'dix-septième', 'dix-huitième', 'dix-neuvième', 'vingtième'
    ];
    
    constructor() {}

    /**
     * Fournis le nombre d'enfants ayant moins de 21 ans et percevant plus de 4500 euros
     * @param listeEnfants: Array<EnfantModel>
     * @returns nbEnfant
     */
    getNombreEnfantMoinsXXansAvecRevenusSuperieur(listeEnfants: Array<EnfantModel>) : number {
        let nbEnfant: number;

        nbEnfant = 0;
        if(listeEnfants === undefined || listeEnfants==null) {
            return nbEnfant;
        }

        listeEnfants.forEach(unEnfant => {
            if(unEnfant.moins21ans && unEnfant.revenue12DernierMois) {
                nbEnfant++;
            }
        });

        return nbEnfant;
    }

    /**
     * Construit le bon nombre de bloc d'enfants
     * @param nbEnfant 
     * @returns EnfantModel[]
     */
    getListeEnfant(nbEnfant: number):EnfantModel[] {

        let index = 0;
        
        const dataList: EnfantModel[] = [];
        
        if(nbEnfant === 0) {
            return dataList;
        }

        do {
           dataList.push(new EnfantModel(index, null, null, false));
            index++;
        } while ( index < nbEnfant)

        return dataList;
    }

    /**
     * 
     * @param index Récupère le libellé selon l'index du tableau indexEnfants
     */
    getLibelle(index: number) : string {
        return this.indexEnfants[index];
    }

    /**
     * 
     * @param codePostal sous forme XXXXX Libellee "78000 Villiers"
     * @returns code postal 
     */
    extractionCodePostal(codePostal: string): number {
        const result = codePostal.substring(0, 5);
        return Number(result);
    }

   /**
     * Fournit l'age de controle de l'enfant
     * Métropole = -21 ans
     * Outre-mer = -22 ans
     * @param codePostal 
     */
    retourneAgeMaxEnfant(codePostal: string) : number {

        if(codePostal===null || codePostal===undefined) {
            return this.getAgeControleEnfant(TypeCodePostalEnum.METROPOLE);
        }

        if(this.estMetropole(this.extractionCodePostal(codePostal))) {
            return this.getAgeControleEnfant(TypeCodePostalEnum.METROPOLE);
        } else {
            return this.getAgeControleEnfant(TypeCodePostalEnum.OUTREMER);
        }
    }

     /**
     * Fournit l'age de controle de l'enfant
     */
    getAgeControleEnfant(typeCode: TypeCodePostalEnum) : number {
        if(typeCode === TypeCodePostalEnum.METROPOLE) {
            return 21;
        } else {
            return 22;
        }
    }

   /**
   * Indique si le code postal vient du métropole ou Outre-mer
   * @param codePostal 
   * @returns true si métropole
   */
   estMetropole(codePostal: number) : boolean {
    if(codePostal && Number(codePostal) >= 97100 && Number(codePostal) <= 97599 ) {
      return false;
    }
    return true;
  }

}
